import React, { type FC, type PropsWithChildren } from 'react';

import Box from '../../components/box/box';
import Divider from '../../components/divider/divider';
import Heading from '../../components/heading/heading';
import Link from '../../components/link/link';
import type { Lucid } from '../../types/types';

export type LinkColumnProps = {
  heading?: string;
  linkItems: Lucid.Directus.Generated.Link_Column_Link[];
  image?: Lucid.Directus.Generated.Directus_Files;
};

const LinkColumn: FC<PropsWithChildren<LinkColumnProps>> = ({ heading, linkItems, image }) => (
  <Box
    as="section"
    css={theme => ({
      display: 'flex',
      flexDirection: 'row-reverse',
      columnGap: theme.space.s32,
      backgroundColor: theme.colors.white,
      padding: theme.space.s32,
      borderRadius: theme.radii.r16,
      alignItems: 'flex-start',
      border: `solid 2px ${theme.colors.coolGrey[20]}`,
      height: '100%',
      [theme.breakpoints.bp1024.min]: {
        flexDirection: 'column',
        alignItems: 'stretch',
      },
    })}
  >
    <Box
      css={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        marginLeft: 0,
      }}
    >
      <Heading as="h2" css={theme => ({ margin: 0, color: theme.colors.coolGrey[100] })} variant="headingL">
        {heading}
      </Heading>
      <Divider
        css={theme => ({
          marginTop: theme.space.s24,
          width: '100%',
        })}
      />
      {linkItems && linkItems.length > 0 && (
        <ul css={theme => ({ marginTop: theme.space.s24 })}>
          {linkItems.map((linkItem, index) => (
            <li
              key={`link-li-${index + 1}`}
              css={theme => ({
                marginTop: index === 0 ? 0 : theme.space.s16,
                listStyleType: 'none',
                marginLeft: `-${theme.space.s16}px`,
              })}
            >
              {linkItem.tag && (
                <span
                  css={theme => ({
                    display: 'inline-block',
                    backgroundColor: theme.colors.pink[60],
                    padding: '8px 10px',
                    borderRadius: theme.radii.r4,
                    marginRight: theme.space.s8,
                    color: theme.colors.white,
                    fontSize: theme.fontSizes.fs16,
                  })}
                >
                  {linkItem.tag}
                </span>
              )}
              <Link
                css={theme => ({
                  fontSize: theme.fontSizes.fs20,
                })}
                href={linkItem.link?.final_url}
                iconAnimation="navigational"
                variant="primary"
              >
                {linkItem.link?.default_link_text}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </Box>
  </Box>
);

export { LinkColumn };
export default LinkColumn;
